import * as React from "react";
import {
  Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
  Grid,
  LinearProgress,
  Link,
  List,
  ListItem, ListItemAvatar, ListItemText,
  Typography, useTheme
} from "@mui/material";
import {Link1, PlainTextSmall, Title5} from "../../../domains/common/components/Typography";
import {useEffect, useState} from "react";
import {actionCodeTitle} from "../../../dictionaries";
import {XmlDocumentIcons} from "../../../domains/common/components/SvgIcons";
import Box from "@mui/material/Box";
import {ErrorsListContainer} from "../../../domains/common/components/Errors";
import {getFIWithSubjectId} from "../participant";
import {DealActionsEnums, handleDealAction} from "../../../actions";
import {ButtonBase} from "../../../domains/common/components/Button";
import {dealData, generateXml} from "../deal";
import {hasStatus} from "../status";
import { DialogWindow } from "../../../domains/common/components/Dialog";


export function XmlList({value}) {
  const [xmlList, setXMLList] = useState(value);
  const [errorsList, setErrorsList] = useState(null);
  const [showProgress, setShowProgressState] = useState(false);
  const [blockBtn, setBlockBtn] = useState(false);

  let progressLine;

  const theme = useTheme();

  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirm = () => {
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleConfirmGenerate = async () => {
    setBlockBtn(true);
    setOpenConfirm(false);
    try {
      await generate();
    } finally {
      setBlockBtn(false);
    }
    setOpenConfirm(false);
  };

  useEffect(() => {
    dealData.xmlGenLock ? setBlockBtn(true) : null;
  }, []);

  const generate = async () => {
    setShowProgressState(true);
    setBlockBtn(true);
    setErrorsList(null);
    const response = await generateXml(dealData.dealId);

    if (response.ok) {
      setXMLList(response.data.xmlList)
      dealData.dealXmlStatementsList = response.data.xmlList;

      handleDealAction(DealActionsEnums.XML_STATEMENT_CREATE);
    } else
      setErrorsList(response)

    setBlockBtn(false);
    setShowProgressState(false);
  };

  if (showProgress) {
    progressLine = <LinearProgress/>
  }
  const actionBtns = (<><DialogActions sx={{display:"flex",justifyContent:'space-between',paddingX:3,paddingBottom:2}}>
            <ButtonBase color="primary" variant="contained" onClick={handleConfirmGenerate} autoFocus>
              {blockBtn ? 'Формируется...' : 'Продолжить'}
            </ButtonBase>
            <ButtonBase color="info" variant="contained" onClick={handleCloseConfirm}>Отмена</ButtonBase>
          </DialogActions></>)
  return (
    <>
    <DialogWindow 
    dialogTitle={'Внимание!'}
    dialogText={"После формирования заявлений все документы по всем участникам будут отозваны с подписания."}
    isOpen={openConfirm}
    onClose={handleCloseConfirm}
    actions={actionBtns}
    />
      <Grid container spacing={1}>
        <Grid item xs={8}><Title5 title="XML-заявления"/></Grid>
        <Grid item xs={4}>
          <Box display="flex" justifyContent="flex-end">
            <ButtonBase
              variant="contained"
              size="small"
              disabled={blockBtn}
              onClick={ hasStatus('documentsSign') || hasStatus('documentsOnSign') ? handleOpenConfirm : generate}
              sx={{
                borderColor: theme.palette.button.border.default,
                color: theme.palette.text.default
              }}>Сформировать</ButtonBase>
          </Box>
        </Grid>
        <Grid item xs={12}>{progressLine}</Grid>
        <Grid item xs={12}>
          {
            errorsList ?
              <ErrorsListContainer error={errorsList}/> : void 0
          }
          {
            dealData.xmlGenLock ? 'Идёт формирование заявлений обновите страницу чуть позже.' : ''
          }
          <List>
            {
              xmlList?.map((xmlFile) => {
                return (
                  <ListItem key={xmlFile.id}>
                    <ListItemAvatar><XmlDocumentIcons size="40"/></ListItemAvatar>
                    <ListItemText primary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{color: 'black', display: 'inline'}}
                        >
                          {getFIWithSubjectId(xmlFile.statementId)}
                        </Typography>
                        <Link1 target="_blank" href={xmlFile.cdnLink}>{xmlFile.name}</Link1>
                      </React.Fragment>
                    } secondary={
                      <PlainTextSmall>
                        {actionCodeTitle[xmlFile.actionCode]}
                      </PlainTextSmall>
                    }
                    />
                  </ListItem>
                )
              })
            }
          </List>
        </Grid>
      </Grid>
    </>
  )
}

